export default __webpack_public_path__ + "static/media/support.50e795f4.svg";